<template>
  <Modal ref="modalRef" class="user-add-modal" @ok="addUser">
    <template #title>Create child account</template>
    <p>
      Create a supervised user account for this profile?
    </p>
    <ProfileCard :person-id="profilePersonIdRef" static/>
    <p class="details">
      You will be the initial account supervisor and will be able to manage all aspects of the account.
      You can add other supervisors once the account is created.
      The supervised user will have limits on what they can do.
      <router-link to="/learn/supervised-users" @click="onNavigate">Learn more</router-link>
    </p>
    <template #okText>Create account</template>
    <template #busyText>Creating...</template>
  </Modal>
</template>

<style lang="scss" scoped>
.profile-card {
  margin: 1rem;
}

.details {
  font-size: 0.875rem;
  color: #888;
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import Modal from '@/util/Modal.vue'
import ProfileCard from '@/manage/ProfileCard.vue'
import { useDataGroupStore } from '@/gp/DataGroupStore';


const profileGroupIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()

const profilePersonIdRef = computed(() => dataGroupStore.getLoadedGroup(profileGroupIdRef.value)?.startItemId)

defineExpose({
  open
})

function open(profileGroupId: string) {
  profileGroupIdRef.value = profileGroupId
  modalRef.value?.open()  
}

async function addUser() {
  const newUserId = await userStore.addForProfileAsync(profileGroupIdRef.value!)
  modalRef.value?.close()
}

function onNavigate() {
  modalRef.value?.close()
}
</script>